
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/document-studio",
      function () {
        return require("private-next-pages/docs/document-studio.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/document-studio"])
      });
    }
  